// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__16oXt","upload":"Small_upload__2h2HD","imageWrap":"Small_imageWrap__3EIBk","removeBtn":"Small_removeBtn__4RX1J"};